import { defineMessages, FormattedMessage, useIntl } from 'react-intl'
import { useSelector } from 'react-redux'

// Constants
import { OVERLAY_HELPERS } from '../../../../../constants/navigation'

// Contexts
import { Box, Icon, Image, useTheme } from '@homebotapp/hb-react-component-catalog'

// Selectors
import { selectRefiShorttermSavings, selectRefiShorttermSavingsKey } from '../../../../../store/selectors/refinance'
import { selectRefi30FixedVideoThumbnail } from '../../../../../store/selectors/videos'

// Components
import { Format, Text } from '../../../..'
import { ImportantNowCard } from '../../ImportantNowCard'

// Assets
import DefaultThemeSvg from './DefaultThemeSvg'
import LightThemeSvg from './LightThemeSvg'

const refiMessages = defineMessages({
  nav: {
    id: 'ImportantNow.refi.nav',
    defaultMessage: '\u25b6 Watch video'
  },
  thumbail: {
    id: 'ImportantNow.refi.thumbnail',
    defaultMessage: 'Thumbnail for video on refinancing'
  }
})

const Refi = () => {
  const intl = useIntl()

  const diffInPayments = useSelector(selectRefiShorttermSavings)
  const refiSavingsKey = useSelector(selectRefiShorttermSavingsKey)
  const videoThumbnailUrl = useSelector(selectRefi30FixedVideoThumbnail)

  const savingsInPayments = Math.abs(diffInPayments)

  const { theme } = useTheme()

  const Svg = theme.isLightThemeType ? LightThemeSvg : DefaultThemeSvg

  // creats video thumbnail component if it exists
  const VideoThumbnail = () => {
    if (!videoThumbnailUrl) return null
    return (
      <Box width='100%' margin='auto' position={'relative'}>
        <Image src={videoThumbnailUrl} alt={intl.formatMessage(refiMessages.thumbail)} width='100%' />
        <Icon
          name='play'
          aria-hidden='true'
          boxSize={10}
          color='white'
          position='absolute'
          top='50%'
          left='50%'
          transform='translate(-50%, -50%)'
          cursor='pointer'
        />
      </Box>
    )
  }

  return (
    <ImportantNowCard
      winType='Refi'
      svgImage={videoThumbnailUrl ? VideoThumbnail : Svg}
      navTo={OVERLAY_HELPERS.refinance.buildPath(refiSavingsKey)}
      navMessage={videoThumbnailUrl && intl.formatMessage(refiMessages.nav)}
      tracking={{
        guid: 'sKhBfRLvx7kVW7j5QoHgYj',
        ui_context: 'homeownerDashboardWinRefi',
        descriptor: 'User clicked on Refi card in Whats Important Now section in Homeowner Dashboard'
      }}
    >
      <FormattedMessage
        id='ImportantNow.spotlight.refi'
        defaultMessage='A 30-year refi could save you around {bold}'
        values={{
          bold: (
            <Text element='span' weight='semibold' variant='success'>
              <Format.Currency value={savingsInPayments} abbreviate />
              <FormattedMessage id='ImportantNow.spotlight.refi.bold' defaultMessage='/mo' />
            </Text>
          )
        }}
      />
    </ImportantNowCard>
  )
}

Refi.propTypes = {}

export default Refi
